import './Nav.css';

const HomeNav = () => {
    return (
        <nav className='custom-nav'>
            <a target='_top' href='https://www.zorgnetwerktrento.be/over-ons'>
                Over Ons
            </a>

            <a
                target='_top'
                href='https://www.zorgnetwerktrento.be/kernwaarden-missie-en-visie'
            >
                Kernwaarden - Missie en Visie
            </a>

            <a
                target='_top'
                href='https://www.zorgnetwerktrento.be/prezo-keurmerk-zorg-en-beleid'
            >
                PREZO-keurmerk in zorg en beleid
            </a>
        </nav>
    );
};
export default HomeNav;
